import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class SignupType extends PureComponent {
  constructor(props) {
    super(props);

    this.updateDetails = this.props.updateDetails;
    this.toNextStep = this.toNextStep.bind(this);
  }

  toNextStep() {
    this.updateDetails(null, null);
  }

  render() {
    // Leaving out FB login for the moment
    // const signUpWithFacebook =
    //   <button className="btn btn-lg btn-block btn-primary">
    //     {strings.signUpWithFacebook}
    //   </button>;

    return (
      <div className="row">
        <div className="col">
          <button className="btn btn-lg btn-block btn-primary" onClick={this.toNextStep} id="signup-type--email">
            {strings.signUpWithEmail}
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupType.jsx